import { ValorationResponse } from '@app/interface/valoration.response';

export const AUTO_VALORATION_INIT: ValorationResponse = {
		titulo: '',
		descripcion: '',
		documento: 
		{ tituloDocumento: '',
			url: ''		},
		comentarioGeneral: {
			urlPhoto: '',
			nombreCompleto: '',
			horaComentario: '',
			comentarioDetail: ''
		},
		preguntas: [
			{
			idPregunta: 1,
			pregunta: '',
			tipoPregunta: '',
			opciones: [
			
			{
				idOpcion: 1 ,
				opcion: ''
			},
			{
				idOpcion: 2 ,
				opcion: ''
			},
			{
				idOpcion: 3 ,
				opcion: ''
			},
			{
				idOpcion: 4 ,
				opcion: ''
			},
			],
			idOpcionSeleccionada: 1,
			comentarioPregunta: {
				urlPhoto: '',
				nombreCompleto: '',
				horaComentario: '',
				comentarioDetail: ''
			},
			},
		],
	}
export const AUTO_VALORATION_EFFECTIVE_COMMUNICATION__COMPETENT: ValorationResponse = {
		titulo: 'Competentes con medios de comunicación',
		descripcion: 'El siguiente documento contiene información relevante que te llevará a comprender qué significa ser competente con los medios de comunicación Pragma para que puedas identificar que tanto lo eres actualmente y así, poder definir una ruta de aprendizaje que te lleve a desarrollar comportamientos que te ayuden a serlo cada vez más',
		documento: 
		{ tituloDocumento: 'COMPETENTES CON LOS MEDIOS DE COMUNICACIÓN PRAGMA',
			url: 'https://docs.google.com/document/d/17T1fK0J_S9qrelIoDmBRurBaBPx9HBDOMyuBEcFJ3LM/edit'
		},
		comentarioGeneral: {
			urlPhoto: 'images/users_avatar/diego_santillan@pragma_com_co_CUADRADO.png',
			nombreCompleto: 'Fernando Diego Santillan Varas',
			horaComentario: '29/02/2024 13:46',
			comentarioDetail: 'Hola Andreina, para este Team PP deberías de conocer mejor los medios de Pragma.'
		},
		preguntas: [
			{
			idPregunta: 1,
			pregunta: 'De acuerdo con el material estudiado ¿Cómo es tu competencia con los medios de comunicación Pragma en este momento?',
			tipoPregunta: 'option',
			opciones: [
			
			{
				idOpcion: 1 ,
				opcion: 'Son pocas las normas en el documento que cumplo'
			},
			{
				idOpcion: 2 ,
				opcion: 'Son muchas las normas descritas en el documento que cumplo pero aún me falta trabajar más'
			},
			{
				idOpcion: 3 ,
				opcion: 'Son casos excepcionales en los que quizás no sigo alguna de las normas descritas en el documento'
			},
			{
				idOpcion: 4 ,
				opcion: 'Soy un referente en el desarrollo de este comportamiento y ayudo a otros a adquirirlo'
			},
			],
			idOpcionSeleccionada: 1,
			comentarioPregunta: {
				urlPhoto: 'images/users_avatar/diego_santillan@pragma_com_co_CUADRADO.png',
				nombreCompleto: 'Fernando Diego Santillan Varas',
				horaComentario: '29/02/2024 13:46',
				comentarioDetail:' Hola Andreina, para este Team PP deberías de conocer mejor los medios de Pragma.'
			},
			},
			{
			idPregunta: 2,
			pregunta: 'En tus conversaciones cotidianas ¿Qué tanto usas el parafraseo para corroborar que entendiste?',
			tipoPregunta: 'option',
			opciones: [
			
				{
					idOpcion: 1 ,
					opcion: 'Son pocas las normas en el documento que cumplo'
				},
				{
					idOpcion: 2 ,
					opcion: 'Son muchas las normas descritas en el documento que cumplo pero aún me falta trabajar más'
				},
				{
					idOpcion: 3 ,
					opcion: 'Son casos excepcionales en los que quizás no sigo alguna de las normas descritas en el documento'
				},
				{
					idOpcion: 4 ,
					opcion: 'Soy un referente en el desarrollo de este comportamiento y ayudo a otros a adquirirlo'
				},
			],
				idOpcionSeleccionada: 1,
				comentarioPregunta: {
					urlPhoto: 'images/users_avatar/diego_santillan@pragma_com_co_CUADRADO.png',
					nombreCompleto: 'Fernando Diego Santillan Varas',
					horaComentario: '29/02/2024 13:46',
					comentarioDetail: 'Hola Andreina, para este Team PP deberías de conocer mejor los medios de Pragma.'
				},
			}
			
		],
	}
